// The planner runs as the single operator signed in through /admin, so every edit is allowed.
const OWNER = { id: "owner", name: "Operator", role: "admin" };
const AUTH = { user: OWNER, account: { name: "Vortex Vending Services" }, loading: false,
  isAdmin: true, canEdit: true, logout: () => {}, reload: () => {} };

export const useAuth = () => AUTH;
